// Keep context identity outside the provider's React Fast Refresh boundary.
import { createContext } from 'react';
import type { ToastType } from '../components/Atoms/Toast/Toast';

export interface ToastContextType {
    showToast: (message: string, type: ToastType, duration?: number) => void;
    removeToast: (id: string) => void;
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined);
